<script lang="ts" setup>
  import { ref, watch, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router/composables';
  import { useDebounceFn } from '@vueuse/core';

  const router = useRouter();
  const route = useRoute();
  const searchbarInput = ref<string>('');
  
  // Initialize searchbar with existing query
  onMounted(() => {
    const searchQuery = route.query.search;
    if (typeof searchQuery === 'string') {
      searchbarInput.value = searchQuery;
    }
  });

  const setRouteSearchQuery = useDebounceFn(() => {
    router.push({
      path: route.path,
      query: {
        ...route.query,
        search: searchbarInput.value || undefined,
      },
    });
  }, 300);

  // Update route when input changes
  watch(() => searchbarInput.value, () => {
    setRouteSearchQuery();
  });

  // Sync with route changes
  watch(() => route.query.search, (newValue) => {
    if (typeof newValue === 'string' && newValue !== searchbarInput.value) {
      searchbarInput.value = newValue;
    }
  });

  // Clear the search
  const clearSearch = () => {
    searchbarInput.value = '';
    setRouteSearchQuery();
  };
</script>

<template>
  <div class="relative w-[280px] min-w-[280px] h-10">
    <!-- Search icon -->
    <i class="icon-search absolute left-5 top-1/2 -translate-y-1/2 text-blue-400 text-sm"></i>
    
    <!-- Input field -->
    <input
      v-model="searchbarInput"
      type="text"
      :placeholder="String($t('generics.search-placeholder', { object: $t('generics.a-campaign') }))"
      class="w-full h-10 rounded-full border border-blue-200 placeholder:text-blue-400 hover:border-blue-500 bg-neutral-100 px-10 text-sm text-blue-900 hover:outline-none hover:ring-blue-300"
    />
    
    <!-- Clear button -->
    <button 
      v-if="searchbarInput.length > 0" 
      class="absolute right-5 top-1/2 -translate-y-1/2 bg-transparent border-none cursor-pointer text-sm text-blue-200 hover:text-blue-700 flex items-center justify-center"
      @click="clearSearch"
    >
      <i class="icon-cross"></i>
    </button>
  </div>
</template>
